import type { CreateCastRelationshipBody } from '../services/sceneService';

export type CastMemberInput = {
  nickname: string;
  entityType: 'User' | 'Member' | 'Character';
  entityId?: string;
  gender?: 'MALE' | 'FEMALE' | null;
  personality?: string;
  ageGapType?: 'YOUNGER' | 'OLDER' | 'SAME';
  occupationType?: 'ACTOR' | 'SINGER' | 'ENTERTAINER' | 'CHARACTER' | 'ETC';
  occupationDescription?: string;
  dataUrl?: string;
};

type MemberPayload = CreateCastRelationshipBody['cast_relationship']['member_a'];

const toCastMember = (input: CastMemberInput): MemberPayload => {
  const member: MemberPayload = {
    nickname: input.nickname,
    entity_type: input.entityType
  };
  if (input.entityId != null && input.entityId !== '') {
    member.entity_id = input.entityId;
  }
  if (input.gender != null) {
    member.gender = input.gender;
  }
  if (input.personality != null && input.personality !== '') {
    member.personality = input.personality;
  }
  if (input.ageGapType != null) {
    member.age_gap_type = input.ageGapType;
  }
  if (input.occupationType != null) {
    member.occupation_type = input.occupationType;
  }
  if (input.occupationDescription != null && input.occupationDescription !== '') {
    member.occupation_description = input.occupationDescription;
  }
  if (input.dataUrl != null && input.dataUrl !== '') {
    member.data_url = input.dataUrl;
  }
  return member;
};

export const buildCreateCastRelationshipBody = (params: {
  memberA: CastMemberInput;
  memberB: CastMemberInput;
  personC: { name: string; gender?: 'MALE' | 'FEMALE' | null };
}): CreateCastRelationshipBody => {
  const person_c: { name: string; gender?: 'MALE' | 'FEMALE' | null } = {
    name: params.personC.name.trim()
  };
  if (params.personC.gender !== undefined) {
    person_c.gender = params.personC.gender;
  }
  return {
    cast_relationship: {
      member_a: toCastMember(params.memberA),
      member_b: toCastMember(params.memberB),
      person_c
    }
  };
};
